<template>
  <div class="calculate-panel">
    <div class="popover-intro" :style="{left:func.left + 'px',top:func.top+'px',display:func.display}" @mouseenter="func.display='block'">
        <div class="function">{{func.value}}</div>
        <div class="title">函数简介</div>
        <div class="tip">{{func.tip}}</div>
        <div class="tip"> 示例：{{func.example}}</div>
    </div>
    <ul v-show="conform.hasCorrectFormula" class="code-mirror" :style="{left:conform.left+'px',top:conform.top+'px'}">
      <li v-for="(item,index) in conform.formulas" :key="index" :class="{'active':conform.active===index}" @click="clickformula(index)">{{item}}</li>
    </ul>
    <div class="left" @mouseleave="func.display='none'">
      <div class="modal-calc">
        <el-tabs v-model="activeName">
          <el-tab-pane label="字段" name="first">
             <div class="modal-columns">
              <i class="add-data-source el-icon-plus" v-if="dataSourceEnable" title="添加辅助表" @click="addDataSourceReport"></i>
             <div class="columns">
              <el-menu class="el-menu-vertical" @open="keywords=[]" :default-openeds="openSubMenus">
                <div v-for="(table, index) in dataSource" :key="index">
                  <el-submenu :index="index.toString()" v-if="table.columns">
                    <span slot="title" :name="table.name">{{table.type === 'OneToMany' ? '*':''}}{{table.name}}</span>
                    <el-input class="search-column" v-if='table.columns.length'  v-model="keywords[index]" @focus="searchKeyword(index,'report')" prefix-icon="el-icon-search" placeholder="请输入搜索的内容"  clearable></el-input>
                     <el-menu-item-group>
                       <el-menu-item v-for="column in table.columns"
                                :key='column.id'
                                :index="column.id"
                                :name="column.name"
                                :type="column.dataType"
                                v-show="column.show"
                                @click='addParam(column,table.relationId,table.name,table.joinType)'>
                         {{column.name}}
                        </el-menu-item>
                      </el-menu-item-group>
                    </el-submenu>
                  </div>
                  <div v-if="dataSourceReport.length!==0" v-for="(datasource,index) in dataSourceReport" :key="'_'+index">
                      <!--生成数据源报表信息用于点击-->
                    <el-submenu :index="'_'+index">
                      <template slot="title">
                        <span slot="title">{{getDataSourceReportName(datasource.dataSourceReportId)}}</span>
                        <i class="el-icon-edit edit-data-source" @click.stop="editDataSource(datasource.dataSourceReportId,index)"></i>
                        <i class="el-icon-error del-data-source" @click.stop="delDataSource(index)"></i>
                      </template>
                      <el-input class="search-column" v-if='datasource.columns.length' v-model="dataSourcekeywords[index]" @focus="searchKeyword(index,'dataSource')" prefix-icon="el-icon-search" clearable></el-input>
                      <el-menu-item-group>
                        <el-menu-item v-for="column in datasource.columns"
                                      :key='column.id'
                                      :index='column.id'
                                      :name="column.name"
                                      :type="column.dataType"
                                      v-show="column.show"
                                      @click='addReportParam(column.id, datasource.dataSourceReportId, column.name)'>
                          {{column.name}}
                        </el-menu-item>
                      </el-menu-item-group>
                    </el-submenu>
                  </div>
                <!-- 本表字段-->
                <div>
                  <el-submenu v-if="currentTableColumns.length > 0" index="currentTable">
                    <span slot="title">本报表列</span>
                    <el-menu-item v-for="column in currentTableColumns"
                                  :key='column.id'
                                  :index="column.id"
                                  :name="column.name"
                                  @click='addCurrentTableColumn(column)'>
                      {{column.name}}
                    </el-menu-item>
                  </el-submenu>
                </div>
                </el-menu>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="函数" name="second">
           <div class="tab-formula">
              <el-input class="search-formula" placeholder="搜索函数" v-model="letfSearch.keyword">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <div @mouseleave="func.display='none'" v-show="!letfSearch.visiable">
                <el-collapse class="func-collapse" v-model="activeNames">
                  <el-collapse-item v-for="(list,index) in options" :key="index" :title="list.label" :name="list.label">
                    <div class="item"  v-for='item in list.children' :key='item.id' @mouseenter="mouseEnter($event,item)" @mouseleave="func.display='none'" @click="insertFormula(item)">
                      <div class="func">{{item.label}}</div>
                      <div class="tip">{{item.abbreviation}}</div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div class="search-collapse" v-show="letfSearch.visiable" >
                <div v-if="letfSearch.list.length>0">
                 <div class="item" v-for='item in letfSearch.list' :key='item.id' @mouseenter="mouseEnter($event,item)" @mouseleave="func.display='none'" @click="insertFormula(item)">
                    <div class="func">{{item.label}}</div>
                    <div class="tip">{{item.abbreviation}}</div>
                 </div>
                </div>
                <div class="no-list" v-else>
                  <img src="./assets/nothing.png" alt="无内容">
                  <p>暂无搜索内容</p>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="right" @mouseenter="func.display='none'">
      <div class="title">计算表达式 <div class="current-func" v-html="currentFunc"></div></div>
      <div class="formula"
                 contenteditable
                 @blur="saveCursor"
                 @input="watchFormula($event)"
                 @paste.prevent="pasteEdit($event)"
                 @click="focusFourmulaFindFunc"
                 ref='formula'
                 v-focus
                 v-html="htmlContent">
      </div>

    </div>
    <el-dialog
      class="data-source-list-mult"
      title="添加辅助表"
      :visible.sync="dataSourceDialog.dialogVisible"
      width="498px"
      :modal="false"
      center>
       <el-form label-width="96px" class="body">
          <el-form-item label="辅助表">
            <el-select placeholder="请选择"
               v-model="dataSourceDialog.dataSourceReportId"
               filterable
               @change="loadTableColumns">
              <el-option
                v-for="item in dataSourceReports"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="line-height" v-for="(filter) in getFilter" :label="filter.name"
                        :key='filter.columnId'>
             <el-select placeholder="请选择" v-model="filter.componentId" filterable clearable>
              <el-option
                v-for="item in getDataSourceColumns"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveDataSourceReport">确 定</el-button>
        <el-button @click="dataSourceDialog.dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="error-formula"
      :visible.sync="errorDialog.dialogVisible"
      width="322px"
      :modal="false"
      center>
      <div v-if="errorDialog.type==='formulaView'" class="formula-view">
        <p class="title">函数存在错误！</p>
        <div class="content">
          <p>你可以检查以下内容</p>
          <ul>
            <li>函数的书写格式是否正确</li>
            <li>计算符号是否为英文字符</li>
            <li v-if='errorDialog.message'>{{errorDialog.message}}</li>
          </ul>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="error-formula"
      :visible.sync="saveDialog.dialogVisible"
      width="322px"
      :modal="false"
      center>
      <div class="save-formula" v-if="saveDialog.type==='saveformulaView'">
        <span>是否保存此修改</span>
        <div slot="footer" class="dialog-footer">
          <el-button  type="primary" @click="buttonClick(1)">保存</el-button>
          <el-button @click="buttonClick(2)">不保存</el-button>
          <el-button @click="buttonClick(3)">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>

</template>

<script type="text/babel">
import {getFormula, enableFormula} from './formula.js'
import _ from 'lodash'
export default {
  name: 'calculation',
  props: ['parameter'],
  data () {
    let options = this.$_.cloneDeep(getFormula())
    this.$axios.get('/system-api/function/list', {params: {'index': 1, 'size': 1000}})
      .then((res) => {
        if (res.data.items.length) {
          if (options.find(n => n.value === 'custom')) {
            options.pop()
          }
          let custom = { id: 'custom', value: 'custom', label: '自定义函数', children: [] }
          res.data.items.forEach(m => {
            if (m.type === 'expression') {
              custom.children.push({id: m.id, tip: m.tip, label: m.name, value: m.value})
            }
          })
          options.push(custom)
        }
      })
    return {
      // 输入公式时符合的公式
      conform: {
        hasCorrectFormula: true,
        formulas: [],
        active: 0
      },
      activeName: 'first',
      // 左侧面板的公式字段
      letfSearch: {
        keyword: '',
        list: [],
        visiable: false
      },
      activeNames: [],
      // 悬浮的公式的介绍
      func: {
        value: '',
        tip: '',
        left: 0,
        top: 0,
        display: 'none'
      },
      options,
      leftPage: {
        value: [],
        tip: '',
        example: '',
        cacheformula: '',
        cacheRange: ''
      },
      expression: '',
      htmlExpression: '',
      functionType: ['simple', 'math', 'text', 'date', 'logic', 'concat'],
      calculationType: 'java',
      dataSource: [],
      currentColumnId: '',
      currentTableColumns: [],
      dataSourceEnable: false,
      dataSourceReports: [],
      dataSourceReport: [],
      dataSourceDialog: {
        dialogVisible: false,
        dataSourceReportId: '',
        dataSourceInfo: {},
        dialogType: 'add'
      },
      keywords: [],
      dataSourcekeywords: [],
      selectKeywordInput: 0,
      needConcat: true,
      regsOptions: [],
      errorDialog: {
        dialogVisible: false,
        message: '',
        type: '',
        time: null
      },
      saveDialog: {
        dialogVisible: false,
        message: '',
        type: ''
      },
      lastExpress: '',
      openSubMenus: [],
      currentFunc: '',
      inputFormulaPostion: {
        lastPosition: 0,
        handleStr: '',
        str: '',
        one: 0,
        hasFiled: false

      }
    }
  },

  created () {
    for (let prop in this.parameter) {
      if (this.parameter.hasOwnProperty(prop)) {
        this[prop] = this.parameter[prop]
      }
    }
    this.openSubMenus = []
    // 默认左侧面板都不展开
    // for (let i = 0; i < this.dataSource.length; i++) {
    //   this.openSubMenus.push(i.toString())
    // }
    // // 本报表列默认展开
    // if (this.currentTableColumns.length > 0) {
    //   this.openSubMenus.push('currentTable')
    // }
  },
  mounted () {
    document.onclick = () => {
      this.conform.hasCorrectFormula = false
      this.showCorrentField('')
    }
    document.onkeydown = (event) => {
      let e = event || window.event
      // 键盘按下事件
      // 38up键 40 down 键
      if (e && e.keyCode === 40) {
        this.conform.active++
        if (this.conform.active >= this.conform.formulas.length) {
          this.conform.active = 0
        }
      }
      if (e && e.keyCode === 38) {
        this.conform.active--
        if (this.conform.active < 0) {
          this.conform.active = this.conform.formulas.length - 1
        }
      }
      if (e.keyCode === 13) {
        if (this.conform.hasCorrectFormula && this.conform.formulas.length) {
          // 点击回车输入到公式栏里
          this.enterInsert()
          this.conform.hasCorrectFormula = false
          return false
        }
      }
    }
    this.$_.cloneDeep(this.options).forEach(m => {
      m.children && m.children.forEach(n => {
        if (n.label && !this.regsOptions.includes(n.label)) {
          this.regsOptions.push(n.label)
        }
      })
    })
    this.showCorrentField('')
    this.leftPage.tip = this.options[0].tip
    this.leftPage.example = this.options[0].example
  },
  watch: {
    'leftPage.cacheRange' (val) {
      document.onkeyup = (event) => {
        let e = event || window.event
        // 38up键 40 down 键  37left  39 righ
        if (e && (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 38 || e.keyCode === 40)) {
          this.focusFourmulaFindFunc()
        }
      }
    },
    'letfSearch.keyword' (val) {
      if (val) {
        this.letfSearch.visiable = true
        this.letfSearch.list = []
        this.options.forEach(m => {
          m.children.forEach(n => {
            if (n.label.toUpperCase().includes(val.toUpperCase())) {
              if (!this.letfSearch.list.find(el => el.label === n.label)) {
                this.letfSearch.list.push({value: n.value, label: n.label, tip: n.tip, example: n.example, abbreviation: n.abbreviation})
              }
            }
          })
        })
      } else {
        this.letfSearch.visiable = false
      }
    },
    keywords (val) {
      let data = this.dataSource
      if (val.length) {
        let value = val[this.selectKeywordInput]
        data[this.selectKeywordInput].columns.forEach(m => {
          if (m.name.includes(value) || (m.pinyinName && m.pinyinName.includes(value)) || (m.pinyinFirstChar && m.pinyinFirstChar.includes(value))) {
            m.show = true
          } else {
            m.show = false
          }
        })
      } else {
        data[this.selectKeywordInput].columns.forEach(m => {
          m.show = true
        })
      }
    },
    dataSourcekeywords (val) {
      let data = this.dataSourceReport
      if (val.length) {
        let value = val[this.selectKeywordInput]
        data[this.selectKeywordInput].columns.forEach(m => {
          if (m.name.includes(value) || (m.pinyinName && m.pinyinName.includes(value)) || (m.pinyinFirstChar && m.pinyinFirstChar.includes(value))) {
            m.show = true
          } else {
            m.show = false
          }
        })
      } else {
        data[this.selectKeywordInput].columns.forEach(m => {
          m.show = true
        })
      }
    }
  },
  computed: {
    getFilter () {
      return this.dataSourceDialog.dataSourceInfo.filters && this.dataSourceDialog.dataSourceInfo.filters.filter(m => m.filterType !== 'senior')
    },
    htmlContent () {
      let expression = this.expression
      if (expression) {
        this.expressionToWithCode(expression)
        return this.htmlExpression
      }
    },
    optionalFuntion () {
      let options = this.options
      options.forEach(el => {
        el.disabled = !this.functionType.includes(el.value)
        enableFormula(this.calculationType)
      })
      return options
    },
    getDataSource () {
      return this.dataSource
    },
    // 获取添加辅助表弹窗筛选项的可选列
    getDataSourceColumns () {
      let allColumns = []
      let dataSource = _.cloneDeep(this.dataSource)
      dataSource.forEach((e, index) => {
        if (e.columns && e.columns.length !== 0) {
          // 给非主表列加前缀
          if (index !== 0) {
            e.columns.forEach(col => {
              col.id = `${col.id}+${e.relationId}`
              col.name = `${e.name}-${col.name}`
            })
          }
          allColumns = allColumns.concat(e.columns)
        }
      })
      return allColumns
    }
  },
  methods: {
    mouseEnter ($event, item) {
      if ($event.toElement.className === 'item') {
        if (this.func.value !== item.value) {
          this.func.left = document.querySelector('.calculate-panel').offsetLeft + 250
          this.func.top = $event.pageY - document.querySelector('.calc-message-box').offsetTop
          this.func.value = item.value
          this.func.tip = item.tip
          this.func.example = item.example
        }
        this.func.display = 'block'
      } else {
        this.func.display = 'none'
      }
    },
    getDataSourceReportName (dataSourceReportId) {
      let table = this.dataSourceReports.find(m => m.id === dataSourceReportId)
      if (table) {
        return table.name
      }
    },
    editDataSource (id, index) {
      this.openDataSourceDialig(id, 'edit', index)
      this.dataSourceDialog.dataSourceInfo = this.dataSourceReport[index]
      return false
    },
    delDataSource (index) {
      let dataSourceReportId = this.dataSourceReport[index].dataSourceReportId
      this.dataSourceReport.splice(index, 1)
      // 辅助表被改就删掉公式
      this.removeSql(dataSourceReportId)
    },
    saveDataSourceReport () {
      if (this.dataSourceDialog.dialogType === 'add') {
        if (this.dataSourceDialog.dataSourceReportId) {
          this.dataSourceReport.push({
            dataSourceReportId: this.dataSourceDialog.dataSourceReportId,
            filters: this.dataSourceDialog.dataSourceInfo.filters,
            columns: this.dataSourceDialog.dataSourceInfo.columns
          })
          this.openSubMenus.push(`_${this.dataSourceReport.length - 1}`)
        }
      } else {
        // 辅助表被改就删掉公式
        this.removeSql(this.dataSourceReport[this.dataSourceDialog.index].dataSourceReportId)

        this.dataSourceReport[this.dataSourceDialog.index] = {
          dataSourceReportId: this.dataSourceDialog.dataSourceReportId,
          filters: this.dataSourceDialog.dataSourceInfo.filters,
          columns: this.dataSourceDialog.dataSourceInfo.columns
        }
      }
      this.dataSourceDialog.dialogVisible = false
    },
    cancelDataSourceReport () {
      this.dataSourceDialog.dialogVisible = false
    },
    addDataSourceReport () {
      this.openDataSourceDialig('', 'add')
      this.dataSourceDialog.dataSourceInfo.filters = []
    },
    openDataSourceDialig (id, type, index) {
      this.dataSourceDialog.dialogVisible = true
      this.dataSourceDialog.dataSourceReportId = id
      this.dataSourceDialog.dialogType = type
      this.dataSourceDialog.index = index
    },

    // 点击数据列
    addParam (column, relationId, tableName, joinType) {
      let id
      let name = column.name
      if (this.parameter.isUseDatasource === true) {
        id = column.expressionText.split('+')[0].split('{')[1]
      } else {
        id = column.id
      }
      let type = column.dataType
      if (joinType && joinType === 'dataSourceReport') {
        type = column.columnType
      }
      if (!this.leftPage.cacheRange) {
        this.$message.info('请选择插入的位置')
        return false
      }
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(this.leftPage.cacheRange)
      // 有符合的输入的值并且有符合的字段
      if (this.inputFormulaPostion.handleStr && this.inputFormulaPostion.hasFiled) {
        let range = this.leftPage.cacheRange
        if (this.inputFormulaPostion.lastPosition === -1) {
          range.setStart(range.startContainer, 0)
        } else {
          range.setStart(range.startContainer, this.inputFormulaPostion.str.length - this.inputFormulaPostion.lastPosition - this.inputFormulaPostion.one)
        }
        range.setEnd(range.startContainer, this.inputFormulaPostion.str.length)
      }
      let html = `&nbsp;<code contenteditable="false" dataid=${id}+${relationId} name=${name} type="${type}" title="${tableName}-${name}">${name}</code>&nbsp;`
      // 替换选中的内容
      document.execCommand('insertHTML', false, html)
      // 清空搜索值
      this.inputFormulaPostion = {
        lastPosition: 0,
        handleStr: '',
        str: '',
        one: 0,
        hasFiled: false
      }
      this.showCorrentField('')
      this.selectParam(this.$refs.formula)
    },

    // 点击报表列
    addReportParam (id, tableId, name) {
      if (!this.leftPage.cacheRange) {
        this.$message.info('请选择插入的位置')
        return false
      }
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(this.leftPage.cacheRange)
      if (this.inputFormulaPostion.handleStr && this.inputFormulaPostion.hasFiled) {
        let range = this.leftPage.cacheRange
        if (this.inputFormulaPostion.lastPosition === -1) {
          range.setStart(range.startContainer, 0)
        } else {
          range.setStart(range.startContainer, this.inputFormulaPostion.str.length - this.inputFormulaPostion.lastPosition - this.inputFormulaPostion.one)
        }
        range.setEnd(range.startContainer, this.inputFormulaPostion.str.length)
      }
      this.selectParam(this.$refs.formula)
      var html = `&nbsp;<code contenteditable="false" dataid=${id}+${tableId} name=${this.getDataSourceReportName(tableId)}-${name} type="sql" title="${this.getDataSourceReportName(tableId)}-${name}">sql(${name})</code>&nbsp;`
      // 替换选中的内容
      // todo: 需要增加判断用于判断当前元素插入何处
      document.execCommand('insertHTML', false, html)
      // 清空搜索值
      this.inputFormulaPostion = {
        lastPosition: 0,
        handleStr: '',
        str: '',
        one: 0,
        hasFiled: false
      }
      this.showCorrentField('')
    },
    // 添加本报表列
    addCurrentTableColumn (column) {
      if (!this.leftPage.cacheRange) {
        this.$message.info('请选择插入的位置')
        return false
      }
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(this.leftPage.cacheRange)
      this.selectParam(this.$refs.formula)
      let html = `&nbsp;<code contenteditable="false" dataid="${column.id}" type="CRC" name=${column.name} title="${column.name}">${column.name}</code>&nbsp;`
      // 替换选中的内容
      document.execCommand('insertHTML', false, html)
    },
    clickformula (index) {
      this.conform.active = index
      this.conform.hasCorrectFormula = false
      this.enterInsert()
      return false
    },
    enterInsert () {
      let range = this.leftPage.cacheRange
      let strPosition = this.leftPage.cacheRange.startOffset
      let str = this.leftPage.cacheRange.startContainer.data && this.leftPage.cacheRange.startContainer.data.slice(0, strPosition)
      let handleStr = str
      if (str) {
        // 截取最后一个非英文以后的值
        let lastPosition = str.split('').reverse().join('').search(/[^a-zA-Z]+/)
        if (lastPosition >= 0) {
          handleStr = str.slice(str.length - lastPosition)
          range.setStart(range.startContainer, str.length - lastPosition)
          range.setEnd(range.startContainer, str.length - lastPosition + handleStr.length)
        } else {
          range.setStart(range.startContainer, 0)
          range.setEnd(range.startContainer, str.length)
        }
        setTimeout(() => {
          let gongshi = null
          let arr = this.$_.cloneDeep(this.options)
          for (let i = 0; i < arr.length; i++) {
            gongshi = arr[i].children.find(n => n.label === this.conform.formulas[this.conform.active])
            if (gongshi) {
              break
            }
          }
          if (gongshi) {
            this.leftPage.cacheformula = _.cloneDeep(gongshi.value).replace(/param/g, '').replace(/\s/g, '')
            this.leftPage.tip = gongshi.tip
            this.leftPage.example = gongshi.example
            let html = ''
            if (this.leftPage.cacheformula === '(DISTINCT)') {
              let formula = 'DISTINCT'
              html = this.leftPage.cacheformula.replace(formula, `<span contenteditable="false">${formula}</span>`)
            } else {
              let formula = this.leftPage.cacheformula.slice(0, this.leftPage.cacheformula.indexOf('('))
              html = this.leftPage.cacheformula.replace(formula, `<span contenteditable="false">${formula}</span>`)
            }
            let sel = window.getSelection()
            sel.removeAllRanges()
            sel.addRange(this.leftPage.cacheRange)
            document.execCommand('insertHTML', false, html)
          }
        }, 100)
      }
    },
    insertFormula (func) {
      let item = _.cloneDeep(func)
      this.currentFunc = item.value
      item.value = _.cloneDeep(item.value).replace(/param/g, '').replace(/\s/g, '')
      this.leftPage.cacheformula = item.value !== 'logicOperation' ? item.value : ''
      this.leftPage.tip = item.tip
      this.leftPage.example = item.example
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(this.leftPage.cacheRange)
      this.selectFormula(this.$refs.formula)
      if (this.leftPage.cacheformula === '(DISTINCT)') {
        let formula = 'DISTINCT'
        let html = this.leftPage.cacheformula.replace(formula, `<span contenteditable='false'>${formula}</span>`)
        document.execCommand('insertHTML', false, html)
      } else {
        let formula = this.leftPage.cacheformula.slice(0, this.leftPage.cacheformula.indexOf('('))
        let html = this.leftPage.cacheformula.replace(formula, `<span contenteditable='false'>${formula}</span>`)
        document.execCommand('insertHTML', false, html)
      }
    },
    selectFormula (selector) {
      selector.focus()
      let sel = window.getSelection()
      if (sel.anchorOffset === 0) {
        sel.selectAllChildren(selector)
        sel.collapseToEnd()
      }
    },
    // 光标选中第一个param
    selectParam (selector) {
      selector.focus()
      let sel = window.getSelection()
      let range = sel.getRangeAt(0)
      for (let i = 0, length = selector.childNodes.length; i < length; i++) {
        if (selector.childNodes[i].nodeName === '#text') {
          let str = selector.childNodes[i].data
          let arr = str.split('param')
          let num = arr.length - 1
          if (num >= 1) {
            // 选择第一个param为光标范围
            range.setStart(selector.childNodes[i], arr[0].length)
            range.setEnd(selector.childNodes[i], arr[0].length + 5)
            break
          }
        }
      }
    },
    pasteEdit (e) {
      let text = e.clipboardData.getData('text')
      let textRange = {}
      if (document.body.createTextRange) {
        // iE中
        text = window.clipboardData.getData('text')
        if (document.selection) {
          textRange = document.selection.createRange()
        } else if (window.getSelection) {
          let sel = window.getSelection()
          let range = sel.getRangeAt(0)
          // 创建临时元素，使得TextRange可以移动到正确的位置
          let tempEl = document.createElement('span')
          tempEl.innerHTML = '&#FEFF;'
          range.deleteContents()
          range.insertNode(tempEl)
          textRange = document.body.createTextRange()
          textRange.moveToElementText(tempEl)
          tempEl.parentNode.removeChild(tempEl)
        }
        textRange.text = text
        textRange.collapse(false)
        textRange.select()
      } else {
        // Chrome之类浏览器
        document.execCommand('insertText', false, text)
      }
    },
    // 输入公式的时候 输入英文的时候找到符合的函数。输入中文找到符合的字段列，输入拼音或者字段的简称，找到字段列
    watchFormula (event) {
      // 输入值的时候
      if (event.data) {
        // 让右侧的提示公式出现
        this.conform.active = 0
        this.conform.left = window.getSelection().getRangeAt(0).getBoundingClientRect().left - document.querySelector('.calc-message-box').offsetLeft + 10
        this.conform.top = window.getSelection().getRangeAt(0).getBoundingClientRect().top - document.querySelector('.calc-message-box').offsetTop + 10
        this.conform.hasCorrectFormula = true
        this.conform.formulas = []
        let sel = window.getSelection()
        if (sel) {
          this.leftPage.cacheRange = sel.getRangeAt(0)
          let range = this.leftPage.cacheRange
          if (sel.anchorNode.data) {
            let strPosition = sel.anchorOffset
            let str = sel.anchorNode.data.slice(0, strPosition)
            // 录入半角左引号，自动补齐右引号，光标在两个引号之间
            if (event.data === "'") {
              document.execCommand('insertText', false, "'")
              sel.collapse(sel.anchorNode, strPosition)
            }
            let handleStr = str
            let handleStrChinese = str
            let pingyinStr = str
            if (str) {
              // 截取最后一个非中文的值，找到输入的中文
              this.findInputChinese(handleStrChinese, str)

              // 截取最后一个非英文以后的值，找到符合的英文
              let lastPosition = str.split('').reverse().join('').search(/[^a-zA-Z]+/)
              if (lastPosition >= 0) {
                handleStr = str.slice(str.length - lastPosition)
                // 截取最后一个非英文以后的值，加上有半角左中括号拼音或者简称找到字段列
                pingyinStr = str.slice(str.length - lastPosition - 1)
              }
              if (pingyinStr[0] === '[') {
                this.inputFormulaPostion = {
                  lastPosition: lastPosition,
                  handleStr: pingyinStr,
                  str: str,
                  one: 1
                }
                this.activeName = 'first'
                this.conform.hasCorrectFormula = false
                this.showCorrentField(handleStr)
              } else if (handleStr) {
                this.inputFormulaPostion = {
                  lastPosition: lastPosition,
                  handleStr: handleStr,
                  str: str,
                  one: 0
                }
                this.replaceCorrentFunc(sel, str, range, handleStr, lastPosition)
              } else {
                // 输入最后一个是非数字的值，并且当前是个函数名的span标签内，得把当前的非英文文字变成普通的颜色。例如SUM(中的(是黑色
                if (lastPosition === 0) {
                  this.conform.formulas = []
                  let newStr = str.slice(str.length - 1)
                  if (sel.anchorNode.parentElement.nodeName === 'SPAN') {
                    let range2 = window.getSelection().getRangeAt(0)
                    range2.setStart(range.startContainer, range2.startOffset - newStr.length)
                    range2.setEnd(range.startContainer, range2.startOffset + newStr.length)
                    setTimeout(() => {
                      document.execCommand('insertHTML', false, newStr)
                      sel.collapseToEnd()
                    }, 100)
                  }
                }
              }
            }
          }
        }
      } else if (event.inputType === 'deleteContentBackward') {
        let sel = window.getSelection()
        if (sel.anchorNode.data) {
          this.leftPage.cacheRange = sel.getRangeAt(0)
          let range = this.leftPage.cacheRange
          let strPosition = sel.anchorOffset
          let str = sel.anchorNode.data.slice(0, strPosition)
          let handleStr = str
          let handleStrChinese = str
          let pingyinStr = str
          if (str) {
            // 截取最后一个非中文的值，找到输入的中文
            this.findInputChinese(handleStrChinese, str)

            // 截取最后一个非英文以后的值
            let lastPosition = str.split('').reverse().join('').search(/[^a-zA-Z]+/)
            if (lastPosition >= 0) {
              handleStr = str.slice(str.length - lastPosition)
              // 截取最后一个非英文以后的值，加上有半角左中括号拼音或者简称找到字段列
              pingyinStr = str.slice(str.length - lastPosition - 1)
            }
            if (pingyinStr[0] === '[') {
              this.inputFormulaPostion = {
                lastPosition: lastPosition,
                handleStr: pingyinStr,
                str: str,
                one: 1
              }
              this.showCorrentField(handleStr)
            } else if (handleStr) {
              this.inputFormulaPostion = {
                lastPosition: lastPosition,
                handleStr: handleStr,
                str: str,
                one: 0
              }
              this.replaceCorrentFunc(sel, str, range, handleStr, lastPosition)
            } else {
              this.conform.hasCorrectFormula = false
            }
          }
        } else {
          this.conform.hasCorrectFormula = false
        }
      }
    },
    // 输入的中文
    findInputChinese (handleStrChinese, str) {
      this.activeName = 'first'
      // 截取最后一个非中文的值
      let lastPositionChinese = str.split('').reverse().join('').search(/[^\u4e00-\u9fa5]+/)
      if (lastPositionChinese >= 0) {
        handleStrChinese = str.slice(str.length - lastPositionChinese)
      }
      this.inputFormulaPostion = {
        lastPosition: lastPositionChinese,
        handleStr: handleStrChinese,
        str: str,
        one: 0,
        hasFiled: false
      }
      this.showCorrentField(handleStrChinese)
    },
    // 字段面板只显示符合中文的列
    showCorrentField (handleStrChinese) {
      this.inputFormulaPostion.hasFiled = false
      if (handleStrChinese) {
        // 搜索字段
        if (handleStrChinese.length) {
          this.dataSource.forEach(el => {
            el.columns.forEach(m => {
              if (m.name.includes(handleStrChinese) || (m.pinyinName && m.pinyinName.includes(handleStrChinese)) || (m.pinyinFirstChar && m.pinyinFirstChar.includes(handleStrChinese))) {
                m.show = true
                this.inputFormulaPostion.hasFiled = true
              } else {
                m.show = false
              }
            })
          })
          this.dataSourceReport.forEach(el => {
            el.columns.forEach(m => {
              if (m.name.includes(handleStrChinese) || (m.pinyinName && m.pinyinName.includes(handleStrChinese)) || (m.pinyinFirstChar && m.pinyinFirstChar.includes(handleStrChinese))) {
                m.show = true
                this.inputFormulaPostion.hasFiled = true
              } else {
                m.show = false
              }
            })
          })
        } else {
          this.dataSource.forEach(el => {
            el.columns.forEach(m => {
              m.show = true
            })
          })
          this.dataSourceReport.forEach(el => {
            el.columns.forEach(m => {
              m.show = true
            })
          })
        }
      } else {
        this.dataSource.forEach(el => {
          el.columns.forEach(m => {
            this.$set(m, 'show', true)
          })
        })
        this.dataSourceReport.forEach(el => {
          el.columns.forEach(m => {
            this.$set(m, 'show', true)
          })
        })
      }
    },
    replaceCorrentFunc (sel, str, range, handleStr, lastPosition) {
      // 输入符合的公式的时候出变色
      let findFunc = this.regsOptions.find(n => n === handleStr)
      if (findFunc) {
        this.conform.hasCorrectFormula = false
        if (lastPosition >= 0) {
          handleStr = str.slice(str.length - lastPosition)
          range.setStart(range.startContainer, str.length - lastPosition)
          range.setEnd(range.startContainer, str.length - lastPosition + handleStr.length)
        } else {
          range.setStart(range.startContainer, 0)
          range.setEnd(range.startContainer, str.length)
        }
        setTimeout(() => {
          document.execCommand('insertHTML', false, '')
          var range1 = window.getSelection().getRangeAt(0)
          var nnode = document.createElement('span')
          range1.surroundContents(nnode)
          nnode.innerHTML = `${handleStr}`
          sel.collapseToEnd()
          this.leftPage.cacheRange = sel.getRangeAt(0)
        }, 100)
      } else {
        if (sel.anchorNode.parentElement.nodeName === 'SPAN') {
          let range = window.getSelection().getRangeAt(0)
          range.setStart(range.startContainer, 0)
          range.setEnd(range.startContainer, handleStr.length)
          document.execCommand('insertHTML', false, handleStr)
          sel.collapseToEnd()
          this.leftPage.cacheRange = sel.getRangeAt(0)
        }
      }
      // 有符合的提示公式会push到数组里
      this.conform.formulas = []
      this.regsOptions.forEach(el => {
        if (el.slice(0, handleStr.length) === handleStr.toUpperCase()) {
          this.conform.formulas.push(el)
        }
      })
    },
    // 公式div的失焦事件
    saveCursor () {
      let sel = window.getSelection()
      if (sel.rangeCount) {
        this.leftPage.cacheRange = sel.getRangeAt(0)
        this.leftPage.cacheRange.anchorNode = sel.anchorNode
        this.leftPage.cacheRange.anchorOffset = sel.anchorOffset
        this.leftPage.cacheRange.focusNode = sel.focusNode
        this.leftPage.cacheRange.focusOffset = sel.focusOffset
      }
    },
    closePanel () {
      this.$emit('close')
      this.$refs.formula.innerHTML = ''
    },
    getHasFilterDataReportId (expression) {
      let hasFilterDataReportList = ''
      expression.match(/\$\{(.+?)\}/g) && expression.match(/\$\{(.+?)\}/g).map((el) => {
        hasFilterDataReportList = el.replace(/[${}]/g, '').split(',')[0].split('+')[1]
      })
      return hasFilterDataReportList
    },
    getValue () {
      let formula = this.$refs.formula.innerHTML
      formula = formula.replace(/<div>/g, '')
      formula = formula.replace(/<\/div>/g, '')
      formula = formula.replace(/<br>/g, '')
      formula = formula.replace(/&amp;/g, '&')
      let handleFormula = this.getExpression(formula)

      handleFormula.match(/sql(.+?)}\)/g) && handleFormula.match(/sql(.+?)}\)/g).forEach(m => {
        let hasFilterDataReportId = this.getHasFilterDataReportId(m)
        let parameters = []
        let dataSourceReportHasFilter = this.dataSourceReport.find(el => el.dataSourceReportId === hasFilterDataReportId)
        if (dataSourceReportHasFilter) {
          dataSourceReportHasFilter.filters && dataSourceReportHasFilter.filters.length !== 0 && dataSourceReportHasFilter.filters.forEach(n => {
            if (n.componentId) {
              // 处理筛选条件在子表的情况
              let relationId = ''
              let columnId = n.componentId
              if (n.componentId.includes('+')) {
                columnId = n.componentId.split('+')[0]
                relationId = n.componentId.split('+')[1]
              }
              let codeAttr = this.find(this.getDataSource, columnId)
              let str = `$\{${columnId}+${relationId || 'undefined'},${codeAttr.column.name},${codeAttr.column.dataType}}`
              parameters.push(`parameter['${n.id}',${str}]`)
            }
          })
        }
        if (parameters.length > 0) {
          handleFormula = handleFormula.replace(m, this.handlerFilter(m, parameters.join(', ')))
        }
      })
      return handleFormula
    },

    handlerFilter (handleFormula, parameter) {
      handleFormula.match(/sql(.+?)}\)/g) && handleFormula.match(/sql(.+?)}\)/g).forEach(m => {
        let sqlStr = m.slice(0, m.indexOf('})' - 1)) + ',' + parameter + '})'
        handleFormula = handleFormula.replace(m, sqlStr)
      })
      return handleFormula
    },

    getExpression (formula) {
      if (formula === '') {
        return formula
      }
      // 处理函数名颜色问题
      formula.match(/<span(.+?)<\/span>/g) && formula.match(/<span(.+?)<\/span>/g).map((el) => {
        let func = el.slice(el.indexOf('>') + 1, el.indexOf('</span>'))
        formula = formula.replace(el, func)
      })

      formula = formula.replace(/&gt;/g, '>')
      formula = formula.replace(/&lt;/g, '<')
      formula.match(/<code(.+?)<\/code>/g) && formula.match(/<code(.+?)<\/code>/g).map((el) => {
        let dataid = el.match(/dataid="(.+?)"/g).toString()
        let type = el.match(/type="(.+?)"/g).toString()
        let name = el.match(/name="(.+?)"/g).toString()
        let newstr = ''
        if (type.includes('sql')) {
          newstr = `sql($\{${dataid.slice(8, dataid.length - 1)},${name.slice(6, name.length - 1)},${type.slice(6, type.length - 1)}})`
        } else {
          newstr = `$\{${dataid.slice(8, dataid.length - 1)},${name.slice(6, name.length - 1)},${type.slice(6, type.length - 1)}}`
        }
        el.replace(el, newstr)
        formula = formula.replace(el, newstr)
      })
      let handleFormula = formula.replace(/&nbsp;/g, '')
      return handleFormula
    },

    validate () {
      let expression = this.getValue()
      return new Promise((resolve, reject) => {
        let cancatFuns = []
        // todo: 获取聚合函数的方式需要修改
        // 获取所有的聚合函数
        this.options.find(m => m.value === 'concat').children.forEach(m => {
          cancatFuns.push(m.value.substring(0, m.value.indexOf('(')))
        })
        cancatFuns = cancatFuns.filter(c => c.trim() !== '')
        expression = expression.replace(/\s/g, '')
        let regs = new RegExp(`(${cancatFuns.join('|')})\\((.+?)\\)`, 'gi')
        let oneToMaycolumns = []
        // DISTINCT 函数需要单独处理，如果包含 DISTINCT 函数 则需要往 oneToMaycolumns push数据
        if (expression.includes('DISTINCT')) {
          oneToMaycolumns.push({
            'functionName': 'DISTINCT',
            'columnId': expression.match(/\$\{(.*?)\}/)[1].split(',')[0].split('+')[0],
            'relationId': expression.match(/\$\{(.*?)\}/)[1].split(',')[0].split('+')[1]
          })
        } else {
          expression.match(regs) && expression.match(regs).map(m => {
            if (!m.match(/sql\((.+?)}\)/g)) {
              if (m.match(/\$\{(.*?)\}/)) {
                m.match(/\$\{(.*?)\}/g).forEach(n => {
                  oneToMaycolumns.push({
                    'functionName': m.substring(0, m.indexOf('(')),
                    'columnId': n.match(/\$\{(.*?)\}/)[1].split(',')[0].split('+')[0],
                    'relationId': n.match(/\$\{(.*?)\}/)[1].split(',')[0].split('+')[1]
                  })
                })
              }
            }
          })
        }
        let oneToOneColumns = []
        expression.match(/\$\{(.*?)\}/g) && expression.match(/\$\{(.*?)\}/g).map(m => {
          let columnId = m.match(/\$\{(.*?)\}/)[1].split(',')[0].split('+')[0]
          let relationId = m.match(/\$\{(.*?)\}/)[1].split(',')[0].split('+')[1]
          let type = m.match(/\$\{(.*?)\}/)[1].split(',')[2] && m.match(/\$\{(.*?)\}/)[1].split(',')[2]
          if (type !== 'sql') {
            let temp = oneToMaycolumns.find(n => n.columnId === columnId && n.relationId === relationId)
            if (!temp) {
              oneToOneColumns.push({
                columnId,
                relationId
              })
            }
          }
        })
        if (this.calculationType.toLocaleLowerCase() === 'java' && this.needConcat) {
          for (let i = 0; i < oneToOneColumns.length; i++) {
            let table = this.getTableByColumnId(oneToOneColumns[i])
            if (table && table.type !== 'OneToOne') {
              let column = table.columns.find(m => m.id === oneToOneColumns[i].columnId)
              reject(new Error(`参数 ${column.name} 需要配合聚合函数使用`))
              break
            }
          }
          for (let i = 0; i < oneToMaycolumns.length; i++) {
            let table = this.getTableByColumnId(oneToMaycolumns[i])
            if (table && table.type !== 'OneToMany') {
              reject(new Error(`函数 ${oneToMaycolumns[i].functionName} 需要选择子表信息(带有 * 号的为子表)`))
              break
            }
          }
        }
        this.$axios.post(`/report-api/report/calculation/verification`, {formula: expression}, {disableInterceptors: true})
          .then(() => {
            resolve()
          }).catch(err => {
            this.errorDialog.dialogVisible = true
            this.errorDialog.message = err.response.data.message
            this.errorDialog.type = 'formulaView'
            if (this.errorDialog.time) {
              clearTimeout(this.errorDialog.time)
              this.errorDialog.time = null
            }
            this.errorDialog.time = setTimeout(() => {
              this.errorDialog.dialogVisible = false
              clearTimeout(this.errorDialog.time)
              this.errorDialog.time = null
            }, 3000)
          })
      })
    },

    getTableByColumnId (column) {
      return this.dataSource.find(m => {
        if (m.columns && m.columns.find(n => n.id === column.columnId)) {
          return m
        }
      })
    },
    // 公式转code
    seniorConvert (expression) {
      if (expression) {
        expression.match(/\$\{(.+?)\}/g) && expression.match(/\$\{(.+?)\}/g).map((el) => {
          let dataid = el.replace(/[${}]/g, '').split(',')[0].split('+')[0]
          let relationId = el.replace(/[${}]/g, '').split(',')[0].split('+')[1]
          let codeAttr = this.find(this.getDataSource, dataid, relationId)
          let code = `&nbsp;<code contenteditable="false" dataid=${codeAttr.column.id}+${codeAttr.relationId} name=${codeAttr.column.name} type="${codeAttr.column.dataType}" title="${codeAttr.tableName}-${codeAttr.column.name}">${codeAttr.column.name}</code>&nbsp;`
          expression = expression.replace(el, code)
        })
        return expression
      }
    },
    // 本表字段表达式转换
    seniorConvertCRC (expression) {
      if (expression) {
        expression.match(/\$\{(.+?)\}/g) && expression.match(/\$\{(.+?)\}/g).forEach((el) => {
          let name = el.split(',')[1]
          let dataId = el.split(',')[0].slice(2)
          let code = `&nbsp;<code contenteditable="false" dataid="${dataId}" type="CRC" name=${name} title="${name}">${name}</code>&nbsp;`
          expression = expression.replace(el, code)
        })
        return expression
      }

      let expressionTmp = expression.match(/\${.*}/g)[0]
      let name = expression.split(',')[1]
      let dataId = expression.split(',')[0].slice(2)
      let html = `&nbsp;<code contenteditable="false" dataid="${dataId}" type="CRC" name=${name} title="${name}">${name}</code>&nbsp;`
      html = expression.replace(expressionTmp, html)
      return html
    },
    expressionToWithCode (expression) {
      let expressionType
      let expressionTmp = expression.match(/{.*}/g) && expression.match(/{.*}/g)[0]
      if (expressionTmp) { expressionType = expressionTmp.split(',')[2] && expressionTmp.split(',')[2].slice(0, -1) }
      if (expressionType && expressionType === 'CRC') {
        // CRC 本报表列的转换
        this.htmlExpression = this.seniorConvertCRC(expression)
        this.lastExpress = this.htmlExpression
      } else {
        this.handleDataSourceReport(expression).then(() => {
          expression = this.handleSqlExpression(expression)
          expression = this.seniorConvert(expression)
          this.htmlExpression = this.handleFuncColor(expression)
          // 为了存上一次打开计算面板的公式
          this.lastExpress = this.htmlExpression
        })
      }
    },
    unique (arr) {
      return Array.from(new Set(arr))
    },
    // 处理公式的函数名颜色
    handleFuncColor (expression) {
      let str = this.regsOptions.join('|')
      // eslint-disable-next-line
      str = eval('/\\b' + str.replace(/\|/g,'\\b|\\b') + '\\b/g')
      // 先把全部span替换成没有span的，然后再讲函数名全部替换成有span
      expression.match(/<span(.+?)<\/span>/g) && expression.match(/<span(.+?)<\/span>/g).map((el) => {
        let func = el.slice(el.indexOf('>') + 1, el.indexOf('</span>'))
        expression = expression.replace(el, func)
      })
      let comfirmOption = this.unique(expression.match(str))
      comfirmOption.forEach(m => {
        // eslint-disable-next-line
        let everyOptions = eval('/\\b' + m + '\\b/g')
        expression = expression.replace(everyOptions, `<span contenteditable="false">${m}</span>`)
      })

      return expression
    },
    // 处理辅助表数据
    handleDataSourceReport (expression) {
      let tableId = ''
      if (expression.match(/sql\((.+?)(}|])\)/g)) {
        return Promise.all(expression.match(/sql\((.+?)(}|])\)/g).map(m => {
          return new Promise((resolve, reject) => {
            if (m.match(/\$\{(.*?)\}/g)) {
              tableId = m.match(/\$\{(.*?)\}/g)[0].replace(/[${}]/g, '').split(',')[0].split('+')[1]
              // 不存在这个辅助表则添加
              if (!this.dataSourceReport.map(m => m.dataSourceReportId).includes(tableId)) {
                let dataSourceReportId = tableId
                this.dataSourceReport.push({
                  dataSourceReportId: dataSourceReportId, filters: [], columns: []
                })
                this.loadTableColumnsAsync(dataSourceReportId).then(() => {
                  m.match(/parameter\[(.+?)\]/g) && m.match(/parameter\[(.+?)\]/g).map(m => {
                    let filterId = m.slice(11, 47)
                    let data = this.dataSourceDialog.dataSourceInfo.filters.find(f => f.id === filterId)
                    if (data) {
                      if (m.slice(51).split(',')[0].split('+')[1] !== 'undefined') {
                        this.$set(data, 'componentId', m.slice(51).split(',')[0])
                      } else {
                        this.$set(data, 'componentId', m.slice(51).split('+')[0])
                      }
                    }
                  })
                  this.dataSourceReport.find(n => n.dataSourceReportId === dataSourceReportId).filters = this.dataSourceDialog.dataSourceInfo.filters
                  this.dataSourceReport.find(n => n.dataSourceReportId === dataSourceReportId).columns = this.dataSourceDialog.dataSourceInfo.columns
                  resolve()
                })
              } else {
                resolve()
              }
            }
          })
        }))
      } else {
        return Promise.resolve()
      }
    },
    // 处理辅助表表达式
    handleSqlExpression (expression) {
      if (expression.match(/sql\((.+?)(}|])\)/g)) {
        let tableId = ''
        expression.match(/sql\((.+?)(}|])\)/g) && expression.match(/sql\((.+?)(}|])\)/g).map(m => {
          if (m.match(/\$\{(.*?)\}/g)) {
            let id = m.match(/\$\{(.*?)\}/g)[0].replace(/[${}]/g, '').split(',')[0].split('+')[0]
            tableId = m.match(/\$\{(.*?)\}/g)[0].replace(/[${}]/g, '').split(',')[0].split('+')[1]
            let name = m.match(/\$\{(.*?)\}/g)[0].match(/\$\{(.*?)\}/)[1].split(',')[1] && m.match(/\$\{(.*?)\}/)[1].split(',')[1]
            let dataSourceName = this.findDataSourceName(tableId, id).name
            name = name.split('-')[0]
            let code = `&nbsp;<code contenteditable="false" dataid=${id}+${tableId} name=${name} type="sql" title="${name}-${dataSourceName}">sql(${dataSourceName})</code>&nbsp;`
            expression = expression.replace(m, code)
          }
        })
      }
      return expression
    },
    findDataSourceName (tableId, id) {
      let dataSourceRport = this.dataSourceReport.find(m => m.dataSourceReportId === tableId)
      let column = null
      if (dataSourceRport && dataSourceRport.columns) {
        column = dataSourceRport.columns.find(el => el.id === id)
      }
      return column
    },
    // 加载公式的时候dataid去数据列中遍历右侧的数据列找到对应列的name,id,tyle,和表名
    find (tables, id, relationId) {
      let column = {}
      let table
      if (relationId === 'undefined' || relationId === undefined) {
        table = tables.find(m => {
          if (this.parameter.isUseDatasource === true) {
            column = m.columns.find(n => n.expressionText.split('+')[0].split('{')[1] === id)
          } else {
            column = m.columns.find(n => n.id === id)
          }
          if (column) {
            relationId = m.relationId
            return m
          }
        })
      } else {
        table = tables.find(m => m.relationId === relationId)
        // 列是辅助表表列 辅助表的dataType 报表列的columnType
        if (table.joinType === 'dataSourceReport') {
          table.columns.forEach(m => {
            m.dataType = m.columnType
          })
        }
        column = table.columns && table.columns.find(m => m.id === id)
      }
      let result = {'column': {}, 'tableName': '', relationId}
      if (column && table) {
        result = {column, 'tableName': table.name, relationId}
      }
      return result
    },
    getTableColumns (val) {
      let dataSourceReport = {}
      if (val) {
        dataSourceReport.filters = []
        dataSourceReport.columns = []
        this.$axios.get(`/report-api/report/definition/${val}?type=run`)
          .then(res => {
            let report = res.data
            report.filters.forEach(m => {
              dataSourceReport.filters.push(this.$_.pick(m, ['id', 'columnId', 'defaultValue', 'name', 'filterType']))
            })
            report.columns.forEach(m => {
              dataSourceReport.columns.push({'id': m.id, 'name': m.name, 'dataType': m.columnType, 'show': true, 'pinyinFirstChar': m.pinyinFirstChar, 'pinyinName': m.pinyinName})
            })
            this.dataSourceDialog.dataSourceInfo = dataSourceReport
          })
      } else {
        // 没有辅助表就为空
        this.dataSourceDialog.dataSourceInfo.filters = []
      }
    },
    loadTableColumns (val) {
      this.getTableColumns(val)
    },
    loadTableColumnsAsync (val) {
      return new Promise((resolve, reject) => {
        let dataSourceReport = {}
        if (val) {
          dataSourceReport.filters = []
          dataSourceReport.columns = []
          this.$axios.get(`/report-api/report/definition/${val}?type=run`)
            .then(res => {
              let report = res.data
              report.filters.forEach(m => {
                dataSourceReport.filters.push(this.$_.pick(m, ['id', 'columnId', 'defaultValue', 'name', 'filterType']))
              })
              report.columns.forEach(m => {
                dataSourceReport.columns.push({'id': m.id, 'name': m.name, 'dataType': m.columnType, 'show': true})
              })
              this.dataSourceDialog.dataSourceInfo = dataSourceReport
              resolve()
            })
        }
      })
    },
    removeSql (dataSourceReportId) {
      let formula = this.$refs.formula === undefined ? '' : this.$refs.formula.innerHTML
      formula.match(/<code(.+?)<\/code>/g) && formula.match(/<code(.+?)<\/code>/g).map((el) => {
        let type = el.match(/type="(.+?)"/g).toString()
        let dataid = el.match(/dataid="(.+?)"/g).toString()
        dataid = dataid.slice(8, dataid.length - 1).split('+')[1]
        if (type === 'type="sql"' && dataid === dataSourceReportId) {
          formula = formula.replace(el, '')
          this.$refs.formula.innerHTML = formula
        }
      })
    },
    searchKeyword (index, type) {
      this.selectKeywordInput = index
    },
    buttonClick (type) {
      this.saveDialog.dialogVisible = false
      this.$emit('closeFourmal', type)
    },
    // 比较修改前后修改后公式是否有变化
    compareExpress () {
      if (this.lastExpress.replace(/"/g, '') !== this.$refs.formula.innerHTML.replace(/"/g, '')) {
        this.saveDialog.type = 'saveformulaView'
        this.saveDialog.dialogVisible = true
      } else {
        this.$emit('closeFourmal', 2)
      }
    },
    focusFourmulaFindFunc () {
      if (window.getSelection().anchorNode.nodeName === 'CODE' && window.getSelection().anchorNode.nodeName === 'DIV') {
        this.currentFunc = ''
      } else {
        let text = this.findLeftBracket(window.getSelection().anchorNode, [], window.getSelection().anchorOffset)
        if (text) {
          let currentFun = ''
          for (let i = 0; i < this.options.length; i++) {
            currentFun = this.options[i].children.find(n => n.label === text[text.length - 1])
            if (currentFun) {
              this.currentFunc = currentFun.value
              break
            }
          }
          // 开始判断哪个param开始高亮
          if (text.length !== 1) {
            let arr = _.cloneDeep(text).reverse().join('')
            // exprTest是取当前鼠标在所属函数的第几个参数 'ROUND((1+1),ABS(MAX(),1)'=> 2
            let currentParamPosition = this.exprTest(arr)
            let paramCount = 0
            // 找出当前前函数有几个param
            let arrayCurrentFunc = this.currentFunc.split(/[,()]/)
            arrayCurrentFunc.forEach((m) => {
              if (m.trim() === 'param') {
                paramCount++
              }
            })
            let handleParam = ''
            for (let i = 0; i < paramCount; i++) {
              let paramStr = paramCount - 1 === i ? 'param' : 'param,'
              handleParam += currentParamPosition - 1 === i ? '<span style="color:#54ABF1">' + paramStr + '</span>' : paramStr
            }
            this.currentFunc = `<span>${text[text.length - 1]}(${handleParam})</span>`
          }
        } else {
          this.currentFunc = ''
        }
      }
    },
    findLeftBracket (element, text, anchorOffset) {
      if (element) {
        let newValue = element.nodeType === 3 ? element.data : element.innerText
        if (anchorOffset || anchorOffset === 0) {
          newValue = newValue.slice(0, anchorOffset)
        }
        // 思路：将鼠标前的值push进行的数组中，然后找右括号的个数比左括号少一个的的是取左括号的函数名
        if (newValue) text.push(newValue)
        let str = _.cloneDeep(text).reverse().join('')
        if (str.split(')').length - 1 === str.split('(').length - 2) {
          let func = element.previousSibling.nodeType === 3 ? element.previousSibling.data : element.previousSibling.innerText
          text.push(func)
          return text
        } else {
          return this.findLeftBracket(element.previousSibling, text)
        }
      }
    },
    exprTest (text) {
      // 思路：将一串字符串逐个的找，找到左括号和逗号push，找到右括号,原来的数组pop，最后剩下最后层函数所存在的左括号和逗号的值
      let pos = 0
      let char = ''
      // groups代表test中的函数各有几个参数
      const groups = []
      const stacks = []
      while (pos < text.length) {
        char = text[pos]
        if (char === '(' || char === ',') {
          stacks.push(char)
        } else if (char === ')') {
          let length = 1
          while (stacks.pop() !== '(') {
            // 遇到一个逗号就参数加1
            length++
          }
          groups.push(length)
        }
        pos++
      }
      let length = 1
      // 最后层函数所存在的左括号和逗号的值
      while (stacks.pop() !== '(') {
        length++
      }
      return length
    }
  }
}

</script>

<style lang="scss">
  .calculate-panel {
  overflow: hidden;

  .popover-intro {
    position: absolute;
    z-index: 9999;
    width: 258px;
    background: #fff;
    border-radius: 4px;
    color: #484646;
    padding: 10px;
    box-shadow:0px 0px 9px 0px rgba(198,201,203,0.28);

    .function {
      border-bottom: 1px solid #EAEAEA;
      color: #484646;
      margin-bottom: 10px;
      padding-bottom: 10px;
      font-size: 12px;
    }

    .title {
      color: #C6C9CB;
      margin-bottom: 8px;
      font-size: 12px;
    }

    .tip {
      font-size: 12px;
    }
  }

  .left {
    width: 286px;
    height: 486px;
    float: left;
    border-right: 1px solid #EAEAEA;

    form {
      >.line-height {
        margin-bottom: 22px;

        .el-form-item__content {
          line-height: 28px;
        }
      }

      .form-item-formula {
        .el-form-item__content {
          line-height: 26px;
        }
      }

      .el-form-item__content {
        margin-left: 44px;
      }

      button.el-button {
        width: 55px;
        height: 28px;
        padding-top: 6px;
      }

      .replace {
        margin-left: -5px;
        -webkit-border-radius: 0 4px 4px 0;
        -moz-border-radius: 0 4px 4px 0;
        border-radius: 0 4px 4px 0;
        border-left: 0;

        &:hover,
        &:active,
        &:focus {
          background-color: #fff;
          color: #606266;
          border-color: #DCDFE6;
        }

        span {
          margin-left: -2px;
        }
      }

      .insert {
        border-right: 0;
        -webkit-border-radius: 4px 0 0 4px;
        -moz-border-radius: 4px 0 0 4px;
        border-radius: 4px 0 0 4px;
      }

      .describe {
        width: 456px;
        height: 84px;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
      }

      .examples {
        width: 456px;
        height: 84px;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
      }
    }
  }

  .right {
    float: left;
    margin-top: 15px;
    margin-left: 26px;
    position: relative;

    .title {
      color: #2A2929;
      .current-func {
        display: inline-block;
        font-size: 12px;
        color: #CAC9C9;
      }
      span {
       font-size: 12px;
      }
    }

    .formula {
      outline: none;
      border: 1px solid #EAEAEA;
      border-radius: 2px;
      padding: 16px;
      height: 358px;
      overflow: auto;
      width: 594px;
      margin-top: 14px;
      line-height:1.8;

      span {
        color: #AC39E7;
      }

      code {
        padding: 2px 4px;
        color: #54ABF1;
        // background-color: #ebf6ff;
        border-radius: 2px;
      }
    }

    .formula.filter {
      height: unset;
    }
  }
}

.modal-calc {
  .el-tabs {
    .el-tabs__header{
      .el-tabs__nav-wrap::after{
        height: 1px;
      }

      .el-tabs__nav {
        #tab-first.el-tabs__item::after,#tab-second.el-tabs__item::after{
          height: 1px;
        }
      }
    }
    .el-tabs__nav {
      width: 100%;

      .el-tabs__active-bar {
        display: none;
      }

      .el-tabs__item {
        width: 50%;
        text-align: center;
        position: relative;
      }

      #tab-first {
        &.is-active::after {
          width: 35px;
          position: absolute;
          background: #409EFF;
          height: 2px;
          bottom: 0;
          left: 45px;
          content: '';
        }
      }

      #tab-second {
        &.is-active::after {
          width: 35px;
          position: absolute;
          background: #409EFF;
          height: 2px;
          bottom: 0;
          left: 65px;
          content: '';
        }
      }
    }

    .el-tabs__content {
      margin-left: 14px;

      .tab-formula {
        .search-formula {
          width: 260px;
        }

        .search-collapse {
          padding: 25px 20px;
          height: 404px;
          overflow: auto;

          .no-list {
            margin: 0 auto;
            width: 72px;
            height: 60px;
            display: block;

            margin-top: 84px;

            p {
              font-size: 12px;
              color: #2A2929;
            }
          }

        }

        .item {
          height: 32px;
          line-height: 32px;
          cursor: pointer;
          position: relative;
          color: #484646;
          font-size: 12px;

          .func {
            color: #484646;
            font-size: 12px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            width: 56%;
          }

          .tip {
            width: 40%;
            font-size: 12px;
            color: #AAA9A9;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            text-align: right;
          }

          &:hover {
            background: #F1F6F9;

          }

          &:active {
            background: #E5EEF4;
          }
        }

        .el-collapse.func-collapse {
          height: 404px;
          overflow: auto;
          border: none;

          .el-collapse-item {

            .el-collapse-item__header {
              padding-left: 20px;
              position: relative;
              color: #2A2929;
              font-size: 14px;

              .el-collapse-item__arrow {
                position: absolute;
                left: 2px;
                top: 50%;
                margin-top: -7px;
              }
            }

            .el-collapse-item__content {
              margin-left: 20px;
            }
          }

        }
      }
    }
  }

  .el-cascader {
    width: 342px;
    line-height: 28px;

    .el-input__inner {
      height: 28px;
      line-height: 28px;
    }
  }

  .modal-columns {
    position: relative;
    .add-data-source {
     position: absolute;
     right: 14px;
     color: #74C3FC;
     cursor: pointer;
     font-size: 12px;
     z-index: 2;
     font-weight: 700;

      &:hover {
        color: #8ecaf9;
      }
      &:active {
        color: #388dd2;
      }
    }

    .columns {
      border-radius: 6px;
      overflow-y: auto;
      max-height: 334px;
      min-height: 334px;

      .el-menu-item-group__title {
        padding: 0;
      }
      .el-menu {
        border-right: none;
      }
      .el-menu>div {
        &.search-column {
          width: 240px;
          margin-left: 18px;
          border-bottom: none;
          margin-top: 8px;
          margin-bottom: 8px;

          .el-input__inner {
            height: 24px;
            line-height: 24px;
          }

          .el-input--mini .el-input__icon {
            line-height: 24px;
          }
        }

        .el-submenu__title {
          width: 100%;
          height: 34px;
          line-height: 34px;
          color: #2A2929;
          position: relative;

          &:hover {
            background: transparent;
              .edit-data-source {
                 display: block;
              }
              .del-data-source {
               display: block;
              }
          }
         .edit-data-source {
              color: #B6B8B9;
              right: 60px;
              display: none;
              position: absolute;
              top: 34%;
              font-size: 12px;
              &:hover {
                color: #8ECAF9;
              }
              &:active {
                  color: #388DD2;
              }
            }

          .del-data-source {
              color: #B6B8B9;
              right: 36px;
              display: none;
              position: absolute;
              top: 34%;
              font-size: 12px;
                &:hover {
                color: #FB9391;
              }
              &:active {
                  color: #EE5451;
              }
            }
          i.el-submenu__icon-arrow {
            color: #2A2929;
            position: absolute;
            top: 55%;
            margin-top: -7px;
            left: 0px;
            font-size: 12px;
            width: 12px;

          }
        }
        .el-menu-item {
          width: 100%;
          height: 24px;
          line-height: 24px;
          padding-left: 21px !important;

        }
      }
    }

  }
}

.data-source-list-mult {
  .el-dialog {
    top: 50%;
    margin-top: -150px !important;
  }
  .el-dialog__header {
    padding: 6px 20px;
    background: #EDEEEE;
    height: 34px;
    color: #2C2C2C;
    border-bottom: 1px solid #D6D9D9;

    .el-dialog__title {
      font-size: 14px;
    }

    .el-dialog__headerbtn {
      top: 10px;
    }
  }

  .el-dialog__footer {
    background: #EDEEEE;

    .dialog-footer {
      .el-button--default {
        background: transparent;
        border: 1px solid rgba(219, 219, 219, 1);
      }
    }
  }

  .el-dialog__body {
    padding: 25px 25px 16px;
    background: #EDEEEE;

    .body {
      overflow: auto;
      height: 185px;
      max-height: 185px;

      .el-input,
      .el-input__inner {
        background: #EDEEEE;
      }

      .el-select>.el-input {
        width: 300px;
        background: #EDEEEE;
      }
    }

  }

}

.code-mirror {
  position: absolute;
  max-height: 400px;
  overflow: auto;
  background: #FFFFFF;
  box-shadow: 0px 0px 9px 0px rgba(198, 201, 203, 0.28);
  border-radius: 4px;
  z-index: 991;

  li {
    min-width: 100px;
    padding: 5px;
    color: #484646;
    font-size: 12px;
    background: #fff;
    cursor: pointer;

    &.active {
      background: #E5EEF4;
    }

    &:hover {
      background: #ECF5FB;
    }

    &:active,
    &:link {
      background: #E5EEF4
    }
  }
}

.error-formula {
  >.el-dialog {
    margin-top: -60px !important;
    top:50%;

  }
  .el-dialog__header {
    background: #EAEAEA;
  }

  .el-dialog__body {
    background: #EAEAEA;
    padding: 10px 25px 30px;
    .formula-view {
      .title {
        text-align: center;
        color: #EE5656;
      }

      .content {
        margin-top: 10px;

        p {
          font-size: 12px;
          color: #9E9F9F;
          margin-bottom: 14px;
        }

        ul {
          li {
            color: #2A2929;
            position: relative;
            padding-left: 10px;
            font-size: 12px;
            line-height: 20px;

            &::before {
              position: absolute;
              left: 0;
              top: 10px;
              content: '';
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background: #54ABF1;
              display: block;
            }
          }
        }
      }
    }
    .save-formula {
      >span {
        text-align: center;
        display: block;
      }
      .dialog-footer {
        margin-top: 38px;
        text-align: center;
        >button {
          width: 76px;
          height: 26px;
          line-height: 25px;
          padding: 0;
        }
        >button.el-button:nth-of-type(2) {
          background: #EDEEEE;
          border:1px solid #54ABF1;
          color: #54ABF1;
          &:hover {
           background: #ecf5ff;
          }
          &:active {
           background: #409EFF;
           color: #fff;
          }
        }
        >button.el-button:nth-of-type(3) {
         background: transparent;
         border:1px solid rgba(219,219,219,1);
        }
      }

    }

  }
}

</style>



// WEBPACK FOOTER //
// src/globalComponent/calculation/calculation.vue